<template>
    <div id="nsi-content" class="nsi-content">
        <dx-button
            v-if="nsiState.isButtonVisible"
            class="flex mr-3"
            @click="goToPreviousLocation"
            icon="return"
            :hint="`Вернуться в ${nsiState.previousRouteTitle}`"
        />
        <local-tree-view
            id="nsi-view"
            ref="treeViewRef"
            :data-source="treeViewData"
            :width="300"
            :meta="meta"
            @item-click="selectItemClick"
            @contentReady="onContentReady"
            class="nsi-tree-view"
        >
            <template #item="{ data }">
                <div class="flex gap-3">
                    <component :is="data.icon" />
                    <span class="ai-nsi-node-text">{{ data.caption }}</span>
                </div>
            </template>
        </local-tree-view>
        <div class="nsi-slovars">
            <div class="flex flex-col h-full w-full overflow-hidden gap-2 pl-2.5">
                <component
                    :is="componentNsiName"
                    @user-settings-changed="onUserSettingsChanged"
                    @user-data-changed="onUserDataChanged"
                    @grid-focus-changed="onGridFocusChanged"
                    @grid-ro-focus-changed="onGridRoFocusChanged"
                    @tree-list-focus-changed="onTreeListFocusChanged"
                    @user-settings-reset="onUserSettingsReset"
                    @refresh="onRefreshHandler"
                    @dataLoaded="onDataLoadedHandler"
                    @changesRemoved="onChangesRemoved"
                    @gridEditWrapperMounted="onGridEditWrapperMounted"
                    @userDataChangedLoaded="onUserDataChangedLoaded"
                    @treeListEditWrapperMounted="onTreeListEditWrapperMounted"
                    @changesSavedSuccessfully="onChangesSavedSuccessfully"
                    ref="instanceRef"
                    :action="getInstance"
                />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'nsi-view',
};
</script>
<script setup>
import { onMounted, onUnmounted, reactive, ref, watch } from 'vue';
import router from '@/router';
import enviromentStore from '@/store/enviroment-data';
import localTreeView from '@/components/local-tree-view.vue';
import { deleteUserSettingsChanges, getUserDataChanges, saveUserDataChanges } from '@/service/userdata-service';
import AiCustomConfirmDialog from '@/utils/ai-custom-confirm-dialog';
import { deleteUserDataChanges } from '@/service/userdata-service';
import DxButton from 'devextreme-vue/button';
import { getNsiTreeviewData } from '@/service/nsi-service';
import {
    setTabReadyToSaveValue,
    setTabRoute,
    setTabTitle,
    tabState,
} from '@/layouts/main-layout/components/navigation-bars-data';
import { setIsDirtyValue } from '@/layouts/main-layout/components/navigation-bars-data';
import { setActiveViewInfo } from '@/layouts/main-layout/main-layout-data';
import { setViewData } from '@/layouts/main-layout/main-layout-data';

const treeViewRef = ref(null);
const treeViewData = ref([]);
const instanceRef = ref();
const nsiInstance = ref();
const refs = ref({});
const gridInstance = ref(null);
const nsiComponentInstance = ref(null);
const treeViewInstance = ref();
const componentNsiName = ref('nsi-group-note-view');
const previousViewId = ref(null);
const changeRouteFromTreeView = ref(false);
const isDirty = ref(false);
const isNsiMounted = ref(false);
const nsiComponentInst = ref();
const treeViewSavedNodeKey = ref(null);
let saveFunc;
let prepareChanges;
let setDataSource;

const { checkAccess } = enviromentStore;

const currentSprav = ref({});
const nsiState = reactive({
    treeListChanges: [],
    gridChanges: [],
    currentSlovarTitle: null,
    currViewId: null,
    previousRoute: null,
    previousRouteTitle: null,
    isButtonVisible: false,
    userSettings: {},
});

watch(isDirty, () => {
    setIsDirtyValue(isDirty.value, saveFunc, prepareChanges, componentNsiName.value, 'nsi-view');
});

const getInstance = async inst => {
    nsiComponentInstance.value = inst.instance;
    nsiComponentInst.value = inst;

    prepareChanges = inst.componentRef?.prepareChangesForSaving;
    setDataSource = inst.setDataSource;
    refs.value[inst.meta.viewId] = inst;
    for (let key in refs.value) {
        saveFunc = refs.value[key].save;
    }

    const updatedNsiComponentState = { ...nsiState.userSettings.settings };
    nsiComponentInstance.value?.state(updatedNsiComponentState);

    switch (inst.instance.NAME) {
        case 'dxDataGrid':
            if (nsiState.gridChanges && nsiState.gridChanges?.length) {
                isDirty.value = true;
                setIsDirtyValue(isDirty.value, saveFunc, prepareChanges, componentNsiName.value, 'nsi-view');
            } else {
                isDirty.value = false;
            }
            break;
        case 'dxTreeList':
            inst.setUserDataChanges(nsiState.treeListChanges, true);

            if (nsiState.treeListChanges && nsiState.treeListChanges?.length) {
                isDirty.value = true;
                setIsDirtyValue(isDirty.value, saveFunc, prepareChanges, componentNsiName.value, 'nsi-view');
            } else {
                isDirty.value = false;
            }
            break;
    }
};

onMounted(async () => {
    let userChangesResult;
    isNsiMounted.value = true;

    if (Object.keys(tabState).length && tabState[window.location.pathname]?.route) {
        userChangesResult = tabState[window.location.pathname].route;
    } else {
        userChangesResult = await getUserDataChanges({ uiRoute: 'nsi-view' });
        treeViewSavedNodeKey.value = userChangesResult.changes?.nodeKey;
        tabState[window.location.pathname] ??= {};
        tabState[window.location.pathname].route = userChangesResult;
    }

    let currRouteName;
    treeViewInstance.value = treeViewRef.value.treeViewInstance;
    if (userChangesResult.changes) {
        currRouteName = userChangesResult.changes.route;
    } else currRouteName = 'nsi-view';
    if (currRouteName) {
        await router.push({
            name: currRouteName,
            params: { app: router.currentRoute.value.params.app, dep: router.currentRoute.value.params.dep },
        });
    }
    await handleDataChanges(currRouteName);
    treeViewData.value = await getNsiTreeviewData(router.currentRoute.value.params.app);

    updateComponentNsiName(currRouteName);

    if (currRouteName) {
        setTimeout(() => {
            treeViewInstance.value.selectItem(currentSprav.value.id);
            treeViewInstance.value.expandItem(currentSprav.value.id);
        }, 0);
    }

    let userManuallyChanges;
    if (userManuallyChanges?.gridChanges) {
        isDirty.value = true;
        nsiState.gridChanges = userManuallyChanges.gridChanges;
    }
});

const onUserDataChangedLoaded = userData => {
    if (userData?.length) {
        isDirty.value = true;
        setIsDirtyValue(isDirty.value, saveFunc, prepareChanges, componentNsiName.value, 'nsi-view');
    }
    nsiState.gridChanges = userData;
};

const onGridFocusChanged = async (row, viewId, rowIndex, component) => {
    const { changes } = await getUserDataChanges({ viewId: currentSprav.value.component });
    let args = {};
    if (changes) {
        args = { ...changes, rowKey: row.key };
    } else {
        args.rowKey = row.key;
    }
    await saveUserDataChanges({ changes: args, viewId: currentSprav.value.component });
    tabState[window.location.pathname] && (tabState[window.location.pathname].changes = args);
};

const onGridRoFocusChanged = async (row, viewId, rowIndex, component) => {
    const { changes } = await getUserDataChanges({ viewId: currentSprav.value.component });
    let args = {};
    if (changes) {
        args = { ...changes, rowKey: row.key };
    } else {
        args.rowKey = row.key;
    }
    await saveUserDataChanges({ changes: args, viewId: currentSprav.value.component });
    tabState[window.location.pathname].changes = args;
};

const onTreeListFocusChanged = async (row, viewId, rowIndex, component) => {
    const { changes } = await getUserDataChanges({ viewId: currentSprav.value.component });
    let args = {};
    if (changes) {
        args = { ...changes, rowKey: row.key };
    } else {
        args.rowKey = row.key;
    }
    await saveUserDataChanges({ changes: args, viewId: currentSprav.value.component });
    // tabState[window.location.pathname].changes = args;
};

const onGridEditWrapperMounted = async () => {
    nsiInstance.value = {
        refresh: setDataSource,
        userData: instanceRef.value.componentRef.setUserDataFromCacheOrApi,
        userSettings: instanceRef.value.componentRef.fetchAndSetUserSettings,
    };
    setActiveViewInfo(nsiInstance.value);

    await setViewData();
    // setTabReadyToSaveValue(true);
};

const onTreeListEditWrapperMounted = async () => {
    nsiInstance.value = {
        refresh: setDataSource,
        userData: instanceRef.value.componentRef.setUserDataFromCacheOrApi,
        userSettings: () => {},
    };
    setActiveViewInfo(nsiInstance.value);

    await setViewData();
    setTabReadyToSaveValue(true);
};

const onUserDataChanged = async args => {
    if (args.changes && args.changes.gridChanges?.length) {
        isDirty.value = true;
        tabState[window.location.pathname] ??= {};
        tabState[window.location.pathname].changes = args.changes.gridChanges;
        saveUserDataChanges(args);
        setTabReadyToSaveValue(true);
    }

    if (args.treeListChanges && args.treeListChanges.length) {
        isDirty.value = true;
        tabState[window.location.pathname] ??= {};
        tabState[window.location.pathname].changes = args.treeListChanges;
        // saveUserDataChanges(args);
        setTabReadyToSaveValue(true);
    }
};

const onRefreshHandler = async () => {
    isDirty.value = false;
    setIsDirtyValue(isDirty.value, saveFunc, prepareChanges, componentNsiName.value, 'nsi-view');
    tabState[window.location.pathname] = null;
    await deleteUserDataChanges({ viewId: currentSprav.value.component });
};

const onChangesRemoved = () => {
    isDirty.value = false;
    setIsDirtyValue(isDirty.value, saveFunc, prepareChanges, componentNsiName.value, 'nsi-view');
};

const onChangesSavedSuccessfully = () => {
    isDirty.value = false;

    tabState[window.location.pathname] && (tabState[window.location.pathname].changes = null);
    setIsDirtyValue(isDirty.value, saveFunc, prepareChanges, componentNsiName.value, 'nsi-view');
};

const getRouteData = routeName => {
    return treeViewData.value.find(el => el.route === routeName);
};

const onUserSettingsReset = async () => {
    gridInstance.value.state({});
    nsiState.userSettings = {};
    await deleteUserSettingsChanges({ viewId: currentSprav.value.component, settings: {} });
    if (tabState[window.location.pathname]?.settings) {
        tabState[window.location.pathname].settings = {};
    }
};

const handleDataChanges = async routeName => {
    if (router.options.history.state.back && !router.options.history.state.back.includes('nsi-view')) {
        let changes;
        nsiState.isButtonVisible = changes?.isButtonVisible;

        const foundRoute = router.getRoutes().find(item => {
            return item.path.startsWith(router.options.history.state.back.split('&')[0]);
        });

        if (nsiState.isButtonVisible) {
            const args = {
                viewId: nsiState.currViewId,
                instanceId: null,
                changes: {
                    previousRoute: router.options.history.state.back,
                    previousRouteTitle: foundRoute.meta.title,
                },
            };
            let changes;
            nsiState.previousRoute = changes.previousRoute;
            nsiState.previousRouteTitle = changes.previousRouteTitle;
        }
    }
};

const updateComponentNsiName = routeName => {
    if (routeName === 'nsi-view') {
        componentNsiName.value = 'nsi-group-note-view';
    } else {
        currentSprav.value = getRouteData(routeName);
        componentNsiName.value = currentSprav.value.component;
    }
};

const goToPreviousLocation = async () => {
    if (nsiState.previousRoute) {
        router.push({
            path: nsiState.previousRoute,
        });
    }
};

const onContentReady = async e => {
    if (treeViewSavedNodeKey?.value) {
        treeViewRef?.value?.treeViewInstance?.scrollToItem(treeViewSavedNodeKey?.value);
    }
};

const selectItemClick = async item => {
    previousViewId.value = componentNsiName.value;

    if (previousViewId.value) {
        if (tabState[window.location.pathname] && tabState[window.location.pathname].changes?.length) {
            const result = await AiCustomConfirmDialog(`Сохранить изменения в ${currentSprav.value.caption}?`);
            if (result === 0) {
                nsiState.gridChanges = [];
                tabState[window.location.pathname] && (tabState[window.location.pathname].changes = null);
                await deleteUserDataChanges({ viewId: currentSprav.value.component });
            }

            if (result === 1) {
                const requestBody = await prepareChanges();
                await saveFunc(requestBody);
            }
            if (result === -1) return;
        }
    }

    changeRouteFromTreeView.value = true;
    nsiState.currentSlovarTitle = item.itemData.caption;
    currentSprav.value = item.itemData;
    componentNsiName.value = item.itemData.component;
    const routeName = item.itemData.route;

    treeViewInstance.value.unselectAll();
    setTabTitle(`НСИ: ${item.node.text}`);
    setTabRoute(routeName);

    await router.push({
        name: routeName,
        params: { app: router.currentRoute.value.params.app, dep: router.currentRoute.value.params.dep },
    });

    const route = router.getRoutes().find(el => el.name === currentSprav.value.route);
    const access = await checkAccess(route?.name);
    componentNsiName.value = !access ? currentSprav.value.component : 'access-denided';
    await treeViewInstance.value.selectItem(currentSprav.value.id);

    if (componentNsiName.value !== 'access-denided') {
        await saveUserDataChanges({
            changes: { route: router.currentRoute.value.name, nodeKey: item?.node?.key },
            uiRoute: 'nsi-view',
        });
        if (!tabState[window.location.pathname]) {
            tabState[window.location.pathname] = {};
            tabState[window.location.pathname].route = {
                result: true,
                changes: { route: router.currentRoute.value.name },
            };
        } else {
            tabState[window.location.pathname].route = {
                result: true,
                changes: { route: router.currentRoute.value.name },
            };
        }
    }
};

onUnmounted(() => {
    treeViewInstance.value.collapseAll();
    treeViewInstance.value.unselectAll();
});

const meta = {
    searchHint: null,
    keyExpr: 'id',
    displayExpr: 'caption',
    parentIdExpr: 'parent_id',
    dataStructure: 'plain',
    rootValue: null,
    selectByClick: true,
    selectionMode: 'single',
    expandEvent: 'dbclick',
    itemTemplate: 'item',
    valueChangeEvent: 'keyup',
};
</script>

<style>
.nsi-content {
    display: flex;
    flex-direction: row;
    height: 100%;
    overflow: hidden;
    padding: 10px 7px 0 10px;
}

.nsi-tree-view {
    min-width: 300px;
    padding-bottom: 30px;
}

.nsi-slovars {
    display: contents;
    height: 100%;
    position: relative;
}
.ai-nsi-node-text {
    font-size: 15px;
}
</style>
